"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CsvParserStream = void 0;
var string_decoder_1 = require("string_decoder");
var stream_1 = require("stream");
var transforms_1 = require("./transforms");
var parser_1 = require("./parser");
var CsvParserStream = /*#__PURE__*/function (_stream_1$Transform) {
  function CsvParserStream(parserOptions) {
    var _this;
    _classCallCheck(this, CsvParserStream);
    _this = _callSuper(this, CsvParserStream, [{
      objectMode: parserOptions.objectMode
    }]);
    _defineProperty(_this, "parserOptions", void 0);
    _defineProperty(_this, "decoder", void 0);
    _defineProperty(_this, "parser", void 0);
    _defineProperty(_this, "headerTransformer", void 0);
    _defineProperty(_this, "rowTransformerValidator", void 0);
    _defineProperty(_this, "lines", '');
    _defineProperty(_this, "rowCount", 0);
    _defineProperty(_this, "parsedRowCount", 0);
    _defineProperty(_this, "parsedLineCount", 0);
    _defineProperty(_this, "endEmitted", false);
    _defineProperty(_this, "headersEmitted", false);
    _this.parserOptions = parserOptions;
    _this.parser = new parser_1.Parser(parserOptions);
    _this.headerTransformer = new transforms_1.HeaderTransformer(parserOptions);
    _this.decoder = new string_decoder_1.StringDecoder(parserOptions.encoding);
    _this.rowTransformerValidator = new transforms_1.RowTransformerValidator();
    return _this;
  }
  _inherits(CsvParserStream, _stream_1$Transform);
  return _createClass(CsvParserStream, [{
    key: "hasHitRowLimit",
    get: function get() {
      return this.parserOptions.limitRows && this.rowCount >= this.parserOptions.maxRows;
    }
  }, {
    key: "shouldEmitRows",
    get: function get() {
      return this.parsedRowCount > this.parserOptions.skipRows;
    }
  }, {
    key: "shouldSkipLine",
    get: function get() {
      return this.parsedLineCount <= this.parserOptions.skipLines;
    }
  }, {
    key: "transform",
    value: function transform(transformFunction) {
      this.rowTransformerValidator.rowTransform = transformFunction;
      return this;
    }
  }, {
    key: "validate",
    value: function validate(validateFunction) {
      this.rowTransformerValidator.rowValidator = validateFunction;
      return this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "emit",
    value: function emit(event) {
      if (event === 'end') {
        if (!this.endEmitted) {
          this.endEmitted = true;
          _superPropGet(CsvParserStream, "emit", this, 3)(['end', this.rowCount]);
        }
        return false;
      }
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      return _superPropGet(CsvParserStream, "emit", this, 3)([event].concat(rest));
    }
  }, {
    key: "_transform",
    value: function _transform(data, encoding, done) {
      // if we have hit our maxRows parsing limit then skip parsing
      if (this.hasHitRowLimit) {
        return done();
      }
      var wrappedCallback = CsvParserStream.wrapDoneCallback(done);
      try {
        var lines = this.lines;
        var newLine = lines + this.decoder.write(data);
        var rows = this.parse(newLine, true);
        return this.processRows(rows, wrappedCallback);
      } catch (e) {
        return wrappedCallback(e);
      }
    }
  }, {
    key: "_flush",
    value: function _flush(done) {
      var wrappedCallback = CsvParserStream.wrapDoneCallback(done);
      // if we have hit our maxRows parsing limit then skip parsing
      if (this.hasHitRowLimit) {
        return wrappedCallback();
      }
      try {
        var newLine = this.lines + this.decoder.end();
        var rows = this.parse(newLine, false);
        return this.processRows(rows, wrappedCallback);
      } catch (e) {
        return wrappedCallback(e);
      }
    }
  }, {
    key: "parse",
    value: function parse(data, hasMoreData) {
      if (!data) {
        return [];
      }
      var _this$parser$parse = this.parser.parse(data, hasMoreData),
        line = _this$parser$parse.line,
        rows = _this$parser$parse.rows;
      this.lines = line;
      return rows;
    }
  }, {
    key: "processRows",
    value: function processRows(rows, cb) {
      var _this2 = this;
      var rowsLength = rows.length;
      var _iterate = function iterate(i) {
        var callNext = function callNext(err) {
          if (err) {
            return cb(err);
          }
          if (i % 100 === 0) {
            // incase the transform are sync insert a next tick to prevent stack overflow
            setImmediate(function () {
              return _iterate(i + 1);
            });
            return undefined;
          }
          return _iterate(i + 1);
        };
        _this2.checkAndEmitHeaders();
        // if we have emitted all rows or we have hit the maxRows limit option
        // then end
        if (i >= rowsLength || _this2.hasHitRowLimit) {
          return cb();
        }
        _this2.parsedLineCount += 1;
        if (_this2.shouldSkipLine) {
          return callNext();
        }
        var row = rows[i];
        _this2.rowCount += 1;
        _this2.parsedRowCount += 1;
        var nextRowCount = _this2.rowCount;
        return _this2.transformRow(row, function (err, transformResult) {
          if (err) {
            _this2.rowCount -= 1;
            return callNext(err);
          }
          if (!transformResult) {
            return callNext(new Error('expected transform result'));
          }
          if (!transformResult.isValid) {
            _this2.emit('data-invalid', transformResult.row, nextRowCount, transformResult.reason);
          } else if (transformResult.row) {
            return _this2.pushRow(transformResult.row, callNext);
          }
          return callNext();
        });
      };
      _iterate(0);
    }
  }, {
    key: "transformRow",
    value: function transformRow(parsedRow, cb) {
      var _this3 = this;
      try {
        this.headerTransformer.transform(parsedRow, function (err, withHeaders) {
          if (err) {
            return cb(err);
          }
          if (!withHeaders) {
            return cb(new Error('Expected result from header transform'));
          }
          if (!withHeaders.isValid) {
            if (_this3.shouldEmitRows) {
              return cb(null, {
                isValid: false,
                row: parsedRow
              });
            }
            // skipped because of skipRows option remove from total row count
            return _this3.skipRow(cb);
          }
          if (withHeaders.row) {
            if (_this3.shouldEmitRows) {
              return _this3.rowTransformerValidator.transformAndValidate(withHeaders.row, cb);
            }
            // skipped because of skipRows option remove from total row count
            return _this3.skipRow(cb);
          }
          // this is a header row dont include in the rowCount or parsedRowCount
          _this3.rowCount -= 1;
          _this3.parsedRowCount -= 1;
          return cb(null, {
            row: null,
            isValid: true
          });
        });
      } catch (e) {
        cb(e);
      }
    }
  }, {
    key: "checkAndEmitHeaders",
    value: function checkAndEmitHeaders() {
      if (!this.headersEmitted && this.headerTransformer.headers) {
        this.headersEmitted = true;
        this.emit('headers', this.headerTransformer.headers);
      }
    }
  }, {
    key: "skipRow",
    value: function skipRow(cb) {
      // skipped because of skipRows option remove from total row count
      this.rowCount -= 1;
      return cb(null, {
        row: null,
        isValid: true
      });
    }
  }, {
    key: "pushRow",
    value: function pushRow(row, cb) {
      try {
        if (!this.parserOptions.objectMode) {
          this.push(JSON.stringify(row));
        } else {
          this.push(row);
        }
        cb();
      } catch (e) {
        cb(e);
      }
    }
  }], [{
    key: "wrapDoneCallback",
    value: function wrapDoneCallback(done) {
      var errorCalled = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return function (err) {
        if (err) {
          if (errorCalled) {
            throw err;
          }
          errorCalled = true;
          done(err);
          return;
        }
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        done.apply(void 0, args);
      };
    }
  }]);
}(stream_1.Transform);
exports.CsvParserStream = CsvParserStream;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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